import { computed, ref } from 'vue'
import * as KnockoutHelpers from './Knockout.helpers'
import * as CommonHeaderHelpers from '@/__core__/components/headers/common-header/CommonHeader.helpers'

export function useKnockoutBloc(knockoutStore, langId, activeTab, isSmallWidgetContainerSize, widgetContainerPaddinglessWidth, cardHeight = 92, scrollIndex = ref(0)) {
  /***** Date & Time Bloc *****/
  const getTime = CommonHeaderHelpers.getTime
  const formatDate = startTime => CommonHeaderHelpers.formatDate(new Date(startTime), langId, 'DD_num MM_short')

  /***** NAVIGATION Bloc *****/
  const shouldDisableScrollingContainerTransition = ref(false)

  const lanesNumber = computed(() => knockoutStore.stages.length)
  const spacing = computed(() => (cardHeight + 8) / 2)

  const cardWidth = computed(() => {
    let lastIndex = lanesNumber.value - 1
    let drawLineSpace = 24
    const maxContentWidth = 768
    const width = Math.min(widgetContainerPaddinglessWidth.value, maxContentWidth)

    if (isSmallWidgetContainerSize.value) {
      // if last lane is active, then avoid adding spacing for draw lines
      drawLineSpace = activeTab.value.index === lastIndex ? 0 : drawLineSpace
      return width - drawLineSpace
    }

    // convert to two column layout
    return width / 2 - drawLineSpace
  })

  const stagesNumber = computed(() => knockoutStore.stages[activeTab.value.index]?.length)
  const hasBottomNavigation = computed(() => stagesNumber.value > 4)
  const isDownNavigationDisabled = computed(() => !hasBottomNavigation.value || stagesNumber.value - scrollIndex.value * 2 <= 4)

  const translateX = computed(() => `translateX(${-activeTab.value.index * (cardWidth.value + 24)}px)`)

  const scrollableContainerStyle = computed(() => ({
    transition: shouldDisableScrollingContainerTransition.value ? 'none' : 'transform .3s'
  }))

  function getDrawLineStyle(laneIndex, activeTabIndex, spacing) {
    // if it is last or second last lane, visually they should stay the same (increas lane by 1 to ensure that fn produces the same result for both stages)
    const adaptedLaneIndex = activeTabIndex >= lanesNumber.value - 2 ? laneIndex + 1 : laneIndex

    return KnockoutHelpers.getDrawLineStyle(adaptedLaneIndex, activeTabIndex, spacing)
  }

  function calculateDrawCardMarginStep(laneIndex, activeTabIndex) {
    // if it is last or second last lane, visually they should stay the same
    if (activeTabIndex >= lanesNumber.value - 2) {
      if (laneIndex === lanesNumber.value - 2) {
        return 1
      } else if (laneIndex === lanesNumber.value - 1) {
        return 3
      }
    }

    return KnockoutHelpers.calculateDrawCardMarginStep(laneIndex, activeTabIndex)
  }

  return {
    getTime,
    formatDate,
    getDrawLineStyle,
    calculateDrawCardMarginStep,
    hasBottomNavigation,
    translateX,
    spacing,
    cardWidth,
    scrollableContainerStyle,
    shouldDisableScrollingContainerTransition,
    lanesNumber,
    isDownNavigationDisabled
  }
}
